module.exports = __webpack_public_path__ + "5ca05960a455ba3f3293f3de228ae39b.pdf";